// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3b9zT","productName":"Table_productName__DX3d3"};